export default "__VITE_ASSET__21e988cf__"